import React, { useEffect, useState } from 'react';
import { sourceService } from '../services/api';
import { useAuthStore } from '../store/useAuthStore';
import styles from './SourcesPanel.module.css';

const SOURCE_TYPES = [
    { value: 'facebook', label: 'فيسبوك' },
    { value: 'twitter',  label: 'تويتر / X' },
    { value: 'news',     label: 'موقع إخباري' },
    { value: 'other',    label: 'أخرى' },
];

export default function SourcesPanel({ protestId, canEdit }) {
    const user = useAuthStore((s) => s.user);
    const [sources,  setSources]  = useState([]);
    const [loading,  setLoading]  = useState(true);
    const [adding,   setAdding]   = useState(false);
    const [saving,   setSaving]   = useState(false);
    const [form,     setForm]     = useState({ source_url: '', source_type: 'facebook' });
    const [error,    setError]    = useState('');

    useEffect(() => {
        sourceService.list(protestId)
            .then((r) => setSources(r.data))
            .catch(console.error)
            .finally(() => setLoading(false));
    }, [protestId]);

    const handleAdd = async (e) => {
        e.preventDefault();
        setSaving(true);
        setError('');
        try {
            const res = await sourceService.create(protestId, form);
            setSources((prev) => [...prev, res.data]);
            setForm({ source_url: '', source_type: 'facebook' });
            setAdding(false);
        } catch (err) {
            setError(err.response?.data?.message || 'فشل الإضافة');
        } finally {
            setSaving(false);
        }
    };

    const handleDelete = async (id) => {
        if (!window.confirm('حذف هذا المصدر؟')) return;
        await sourceService.delete(protestId, id);
        setSources((prev) => prev.filter((s) => s.id !== id));
    };

    const typeLabel = (val) => SOURCE_TYPES.find((t) => t.value === val)?.label ?? val;

    if (loading) return <div className={styles.state}>جاري التحميل...</div>;

    return (
        <div className={`${styles.panel} text-ar`}>
            <div className={styles.panelHeader}>
                <h3 className={styles.panelTitle}>المصادر ({sources.length})</h3>
                {canEdit && !adding && (
                    <button className={styles.addBtn} onClick={() => setAdding(true)}>+ إضافة مصدر</button>
                )}
            </div>

            {adding && (
                <form onSubmit={handleAdd} className={styles.addForm}>
                    {error && <div className={styles.error}>{error}</div>}
                    <div className={styles.formRow}>
                        <input
                            className={styles.input}
                            type="url"
                            placeholder="https://..."
                            value={form.source_url}
                            onChange={(e) => setForm({ ...form, source_url: e.target.value })}
                            required
                        />
                        <select
                            className={styles.input}
                            value={form.source_type}
                            onChange={(e) => setForm({ ...form, source_type: e.target.value })}
                        >
                            {SOURCE_TYPES.map((t) => (
                                <option key={t.value} value={t.value}>{t.label}</option>
                            ))}
                        </select>
                        <button type="submit" className={styles.saveBtn} disabled={saving}>
                            {saving ? '...' : 'حفظ'}
                        </button>
                        <button type="button" className={styles.cancelBtn} onClick={() => setAdding(false)}>إلغاء</button>
                    </div>
                </form>
            )}

            {sources.length === 0 && !adding && (
                <p className={styles.empty}>لا توجد مصادر مضافة بعد</p>
            )}

            <div className={styles.list}>
                {sources.map((s) => (
                    <div key={s.id} className={styles.item}>
                        <div className={styles.itemBody}>
                            <span className={styles.typeTag}>{typeLabel(s.source_type)}</span>
                            <a href={s.source_url} target="_blank" rel="noopener noreferrer" className={styles.link}>
                                {s.source_url}
                            </a>
                            {s.creator && (
                                <span className={styles.meta}>أضافه: {s.creator.name}</span>
                            )}
                        </div>
                        {(user?.role === 'super_admin' || user?.id === s.created_by) && (
                            <button className={styles.deleteBtn} onClick={() => handleDelete(s.id)}>🗑</button>
                        )}
                    </div>
                ))}
            </div>
        </div>
    );
}
